import { defineApp } from '../../shell/registry';
import { TENANT_IDS } from '../../shell/session/tenants';

export default defineApp({
    id: 'sale-intake',
    path: 'sale-intake',
    title: 'Sale Intake',
    icon: 'mdi-cart-plus',
    description: 'Build a Sale document, POST it to intake, and confirm it landed in the graph.',
    tenants: [TENANT_IDS.gearNest],
    component: () => import('./SaleIntakeApp.vue'),
});
